import {
  Modal,
  message,
  Row,
  Col,
  Button,
  Table,
  FloatButton,
  Spin,
  Space,
  Calendar,
  Badge,
  Select,
  Segmented,
} from "antd";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  BASE_URL_BEN,
  GET_LIST_INVESTIGATE_ONLINE,
  HEADERS_EXPORT_BEN,
  POST_LIST_INVESTIGATE_ONLINE,
  POST_LOAN_DB2_V2,
} from "../../../API/apiUrls";
import dayjs from "dayjs";
import {
  FileExcelOutlined,
  InfoCircleOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { exportExcelInvestigate } from "../report/ExportExcelInvestigate";
import ListExportInvestigate from "./ListExportInvestigate";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { Link } from "react-router-dom";

const ExportListInvestigateRound = ({ open, close }) => {
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [loading, setLoading] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [arrData, setArrData] = useState([]);
  const scrollRef = useRef(null); // กล่องที่ให้เลื่อนภายใน
  const [
    isModalExportListInvestigateDetail,
    setIsModalExportListInvestigateDetail,
  ] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [calendarPoint, setCalendarPoint] = useState([]);
  const [btnCheckCalendar, setBtnCheckCalendar] = useState(false);
  const [calendarMode, setCalendarMode] = useState("month"); // 'month' | 'year'
  const [calendarValue, setCalendarValue] = useState(dayjs()); // ค่าวัน/เดือนที่แสดง
  const [datePicker, setDatePicker] = useState(null);

  useEffect(() => {
    loadRoundData();
  }, []);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
  };

  const handleClear = () => {
    setArrayTable([]);
    setDatePicker([]);
  };

  const loadRoundData = async () => {
    setLoading(true);
    try {
      await axios
        .get(BASE_URL_BEN + GET_LIST_INVESTIGATE_ONLINE, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (res) => {
          console.log("res.data", res.data);

          if (res.status === 200) {
            if (res.data.message === "ไม่พบข้อมูล") {
              message.warning("ไม่พบข้อมูล");
            } else {
              setCalendarPoint(res.data);
            }
          } else {
            message.error("ไม่มีข้อมูล");
            console.log("res Role", res.data);
            setArrayTable([]);
            setArrData([]);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const queryData = (item, type) => {
    console.log("item---->", item);
    if (type === "array") {
      loadData(item);
    } else {
      loadData([item]);
    }
  };

  const loadData = async (payload) => {
    setLoading(true);
    console.log("payload", payload);

    try {
      await axios
        .post(BASE_URL_BEN + POST_LIST_INVESTIGATE_ONLINE, payload, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (res) => {
          console.log("res.data", res.data);
          let i = 1;

          if (res.status === 200) {
            if (res.data.success === "ไม่พบข้อมูล") {
              message.warning("ไม่พบข้อมูล");
            } else {
              const newData = res.data.map((item) => ({
                ...item,
                key: i++,
              }));
              setArrData(newData);
              setArrayTable(newData);
            }
          } else {
            message.error("ไม่มีข้อมูล");
            console.log("res Role", res.data);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err);
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    setLoading(true);
    const useData = arrayTable;

    try {
      const seenContno = new Set();
      const groupedBySchema = useData.reduce((acc, item) => {
        if (!item.contno || !item.SCHEMA) return acc;
        if (seenContno.has(item.contno)) return acc; // ✅ contno ซ้ำ ข้าม
        seenContno.add(item.contno);

        const schemaKey =
          userCompany === "3" && item.SCHEMA !== "rpsl"
            ? `${item.SCHEMA}_ksm`
            : item.SCHEMA;

        if (!acc[schemaKey]) acc[schemaKey] = [];
        acc[schemaKey].push(`'${item.contno}'`);
        return acc;
      }, {});

      const schemaPayload = Object.entries(groupedBySchema).reduce(
        (acc, [schema, arr]) => {
          acc[schema] = arr.join(",");
          return acc;
        },
        {},
      );

      // ── 2. ยิง DB2 ────────────────────────────────────────────
      let db2Map = {};
      try {
        const db2Res = await axios.post(POST_LOAN_DB2_V2, schemaPayload, {
          headers: HEADERS_EXPORT_BEN,
        });

        const raw = db2Res.data;
        const db2Data = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.data)
            ? raw.data
            : raw?.LOAN
              ? [raw] // ✅ กรณี API คืน object เดียว
              : [];

        db2Data.forEach((item) => {
          const contno = item?.LOAN?.CONTNO;
          if (!contno) return;

          // เก็บ raw ไว้ทั้งก้อน แล้วค่อยเลือกคน + address ตอน merge ตาม garno
          db2Map[contno] = {
            CUSTOMER: item.CUSTOMER ?? {},
            GUARANTORS: item.GUARANTORS ?? [],
            LOCAT: item.LOAN?.LOCAT,
          };
        });
      } catch (e) {
        console.warn("DB2 failed:", e);
      }

      // ── 3. merge: เลือกคนตาม garno แล้วเก็บ ADDRESS เป็น array ──
      const mergedData = useData.map((item) => {
        const db2 = db2Map[item.contno];
        if (!db2) return { ...item };

        const garno = Number(item.garno) || 0;

        const person =
          garno === 0
            ? db2.CUSTOMER
            : (db2.GUARANTORS.find((g) => Number(g.GARNO) === garno) ?? null);

        return {
          ...item,
          LOCAT: db2.LOCAT,
          OFFIC: person?.OFFIC ?? "",
          OCCUP: person?.OCCUP ?? "",
          RELATN: person?.RELATN ?? "",
          ADDRESS: person?.ADDRESS ?? [], // ✅ เก็บทุก address เป็น array
        };
      });

      // ── 4. export ─────────────────────────────────────────────
      await exportExcelInvestigate(mergedData);
      message.success("โหลด Excel สำเร็จ");
    } catch (e) {
      message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 20,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "contno",
      key: "contno",
      align: "center",

      render: (text, record) => <>{record.contno}</>,
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "dateRound",
      key: "dateRound",
      align: "center",

      render: (text, record) => (
        <>
          {record.SNAM} {record.NAME1} {record.NAME2}
        </>
      ),
    },
    {
      title: "สถานะ",
      dataIndex: "dateRound",
      key: "dateRound",
      align: "center",

      render: (text, record) => (
        <>{record.garno === 0 ? "ผู้เช่าซื้อ" : `ผู้ค้ำที่ ${record.garno}`}</>
      ),
    },
    {
      title: "วันที่ร้องขอสืบ",
      dataIndex: "dateCeoInvestigate",
      key: "dateCeoInvestigate",
      align: "center",
      render: (text, record) => (
        <>
          {dayjs(record.dateCeoInvestigate)
            .add(543, "year")
            .format("DD MMM YY")}
        </>
      ),
    },
    {
      title: "วันที่อนุมัติสืบ",
      dataIndex: "dateSend",
      key: "dateSend",
      align: "center",

      render: (text, record) => (
        <>{dayjs(record.dateSend).add(543, "year").format("DD MMM YY")}</>
      ),
    },
  ];

  const onChangeDate = (value) => {
    console.log(value);
    setBtnCheckCalendar(false);
    handleClear();
  };

  const TableData = () => {
    return (
      <div
        ref={scrollRef}
        style={{
          maxHeight: 800, // กำหนดความสูงให้เกิดสกอร์ล
          overflow: "auto",
          position: "relative", // ให้ float วางอิงกล่องนี้ได้
        }}
      >
        <Row>
          <Col xs={12} md={12} style={{ textAlign: "start" }}>
            <Space size={16}>
              <Button
                icon={<ArrowLeftOutlined />}
                size="large"
                type="primary"
                ghost
                onClick={() => {
                  setBtnCheckCalendar(false);
                  handleClear();
                }}
                disabled={loading}
              >
                ย้อนกลับ
              </Button>
              <ThaiDatePicker
                value={datePicker}
                onClick={(value) => onChangeDate(value)}
                size="large"
                disabled
              />
            </Space>
          </Col>
          <Col xs={12} md={12} style={{ textAlign: "end" }}>
            <Space size={8} wrap>
              <Button
                icon={<FileExcelOutlined />}
                size="middle"
                loading={loading}
                style={{
                  borderRadius: 8,
                  fontWeight: 600,
                  color: "#16a34a",
                  borderColor: "#16a34a",
                }}
                onClick={handleExportExcel}
                disabled={arrayTable.length === 0}
              >
                ดาวน์โหลด Excel
              </Button>
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table
              size="large"
              rowKey={(r) => r.key}
              columns={columns}
              dataSource={arrayTable}
              pagination={false}
              bordered
              style={{ marginTop: 16 }}
              footer={() => (
                <div
                  style={{
                    textAlign: "right",
                    fontWeight: 600,
                    fontSize: 16,
                  }}
                >
                  จำนวนสัญญา {new Set(arrayTable?.map((r) => r.contno)).size}{" "}
                  สัญญา
                  <br />
                  จำนวนลูกค้า {arrayTable?.length} คน
                </div>
              )}
            />
            <FloatButton.BackTop />
          </Col>
        </Row>
        <FloatButton.BackTop
          target={() => scrollRef.current} // ฟังสกอร์ลจากกล่องนี้
          visibilityHeight={80} // โผล่เมื่อเลื่อนเกิน 80px
          style={{ right: 16, bottom: 16 }}
        />
      </div>
    );
  };

  const getListData = (value) => {
    return (
      calendarPoint?.filter((item) =>
        dayjs(item.dateRound).isSame(value, "day"),
      ) || []
    );
  };

  const dateCellRender = (value) => {
    const listData = getListData(value);
    return (
      <>
        {listData.length > 0 && (
          <div style={{ textAlign: "center", marginBottom: 4 }}>
            <Badge count={<InfoCircleOutlined style={{ color: "blue" }} />} />
          </div>
        )}
        {listData.map((item, index) => (
          <li key={index}>
            <Badge
              status="success"
              text={
                <div style={{ whiteSpace: "normal" }}>
                  <Link
                    onClick={() => {
                      // คลิกลิงก์ใน cell = เลือก "วัน"
                      setCalendarValue(dayjs(item.dateRound));
                      setDatePicker(dayjs(item.dateRound));
                      setBtnCheckCalendar(true);
                      queryData(item);
                    }}
                  >
                    ดูเพิ่มเติม
                  </Link>
                </div>
              }
            />
          </li>
        ))}
      </>
    );
  };

  const getMonthCount = (value) => {
    const targetMonth = value.month(); // 0-11
    const targetYear = value.year();

    const filtered = calendarPoint?.filter((item) => {
      const date = dayjs(item.dateRound);
      return date.year() === targetYear && date.month() === targetMonth;
    });

    return filtered?.length || 0;
  };

  const monthCellRender = (value) => {
    const count = getMonthCount(value);

    return count > 0 ? (
      <div style={{ textAlign: "center", paddingTop: 8 }}>
        <Badge count={count} style={{ backgroundColor: "blue" }} />
      </div>
    ) : null;
  };

  const cellRender = (current, info) => {
    if (info.type === "date") return dateCellRender(current);
    if (info.type === "month") return monthCellRender(current);
    return info.originNode;
  };

  // --- เมื่อคลิกเลือกในปฏิทิน ---
  const handleSelect = (value) => {
    console.log("handleSelect", value);

    if (calendarMode === "year") {
      // คลิก "เดือน" ขณะอยู่โหมดปี -> เปลี่ยนไปโหมดเดือนของเดือนนั้น (ไม่ query)
      setCalendarMode("month");
      setCalendarValue(value);
      return;
    }
    setLoading(true);
    const dataLoad = calendarPoint.filter((item) =>
      dayjs(item.dateRound).isSame(dayjs(value), "day"),
    );

    setCalendarValue(value);
    setDatePicker(value);
    setBtnCheckCalendar(true);
    queryData(dataLoad, "array");
  };

  // --- เมื่อเปลี่ยนแผง (สลับเดือน/ปี หรือเปลี่ยนเดือนจากหัวปฏิทิน) ---
  const handlePanelChange = (value, mode) => {
    console.log("handlePanelChange", value, mode);
    setCalendarValue(value);
    setCalendarMode(mode);
  };

  const CalendarList = () => (
    <div>
      <Calendar
        value={calendarValue}
        mode={calendarMode}
        onSelect={handleSelect}
        onPanelChange={handlePanelChange}
        cellRender={cellRender}
        headerRender={({ value, type, onChange, onTypeChange }) => {
          const cur = value.clone();
          const years = Array.from(
            { length: 11 },
            (_, i) => dayjs().year() - 5 + i,
          );
          const months = Array.from({ length: 12 }, (_, i) => ({
            value: i,
            label: dayjs().month(i).format("MMM"),
          }));
          return (
            <div
              style={{
                display: "flex",
                gap: 8,
                justifyContent: "flex-end",
                padding: 8,
              }}
            >
              <Select
                size="small"
                value={cur.year()}
                options={years.map((y) => ({ value: y, label: y }))}
                onChange={(y) => {
                  onChange(cur.year(y));
                  setBtnCheckCalendar(false);
                }}
              />
              <Select
                size="small"
                value={cur.month()}
                options={months}
                onChange={(m) => {
                  onChange(cur.month(m));
                  setBtnCheckCalendar(false);
                }}
                disabled={type === "year" ? true : false}
              />
              <Segmented
                size="small"
                value={type === "year" ? "Year" : "Month"}
                options={["Month", "Year"]}
                onChange={(v) => onTypeChange(v === "Year" ? "year" : "month")}
              />
            </div>
          );
        }}
      />
      <Row>
        <Col span={24} style={{ textAlign: "end" }}>
          <Button
            icon={<ArrowRightOutlined />}
            size="large"
            type="primary"
            danger
            ghost
            onClick={() => setBtnCheckCalendar(true)}
            disabled={loading}
          >
            ข้าม
          </Button>
        </Col>
      </Row>
    </div>
  );

  return (
    <Spin spinning={loading} size="large" tip=" Loading... ">
      <Modal
        title={
          <span style={{ fontSize: 16, fontWeight: 400, color: "#333" }}>
            นำออกข้อมูลสืบทรัพย์
          </span>
        }
        open={open}
        onCancel={handleCancel}
        width={850}
        // width={btnCheckCalendar ? "auto" : 850}
        footer={null}
        keyboard={true}
        centered
        styles={{
          body: { padding: "24px 32px" }, // ใช้แทน styles.body
        }}
      >
        {!btnCheckCalendar ? CalendarList() : TableData()}
        {isModalExportListInvestigateDetail ? (
          <ListExportInvestigate
            open={isModalExportListInvestigateDetail}
            close={setIsModalExportListInvestigateDetail}
            data={dataList}
          />
        ) : null}
      </Modal>
    </Spin>
  );
};
export default ExportListInvestigateRound;
